<div [formGroup]="formGroup" class="option-toggle" [ngClass]="{'checked': formControl.value}" (click)="toggleControl()">
    <i class="option-toggle-icon" *ngIf="icon" [ngClass]="icon"></i>
    <mat-checkbox [formControlName]="controlName" (change)="toggleControl()" [disableRipple]="true" class="checkbox-hidden filter-option-checkbox">
        {{ label || 'Toggle Option' }}
    </mat-checkbox>
    <i class="bhi-check" *ngIf="formControl.value"></i>
    <i class="bhi-circle-o" *ngIf="!formControl.value"></i>
</div>
